import { BLANKS_GROUP, TRANSFERS_GROUP } from "../app-registry/contants";

const businessLineToUrlGroup = businessLine => {
  if (BLANKS_GROUP.includes(businessLine)) return "blanks";
  if (TRANSFERS_GROUP.includes(businessLine)) return "transfers";
  return null;
};

export default businessLineToUrlGroup;
